import TeamBaseModel from './team-base';
import UserModel, { fetchUser } from './user';

import teamService from '@/services/API/team/index';
import { rHandler } from '@/plugins/RHandler';

export default class TeamEvent extends TeamBaseModel {
  constructor(team, url) {
    super(team, url);

    this.trainer_id = team.trainer_id || null;
    this.searchable = team.searchable || false;
    this.max_members = team.max_members || 1;
    this.open_set = team.open_set || false;
    this.free_entrance = team.free_entrance || false;
    this.event_stage_id = team.event_stage_id || null;
    this.parent_id = team.parent_id || null;
    this.complete = team.complete || false;
    this.is_for_transfer = team.is_for_transfer || false;
    this.team_pattern_id = team.team_pattern_id || null;
    this.event_id = team.event_id || null;
    this.creator_id = team.creator_id || null;

    this.trainer = team.trainer ? new UserModel(team.trainer) : null;
  }

  async fetchTrainerProfile() {
    if (!this.trainer?.id) return {};
    const { response, error } = await fetchUser(this.trainer?.id);
    const [trainerData] = response?.data?.data || [];
    if (!error && trainerData) {
      this.trainer = new UserModel(trainerData);
    }
    return { response, error };
  }

  async addMembers(params) {
    const { addMembersToTeam, addMembersByOwner } = teamService;
    const method = this.isOwner ? addMembersByOwner : addMembersToTeam;
    const answer = await rHandler(
      method(this.id, params),
      (response) => ({ response }),
      (error) => ({ error }),
    );
    return { ...answer };
  }

  async removeMembers(params) {
    const answer = await rHandler(
      teamService.excludeEventStageMembers(this.id, params),
      (response) => ({ response }),
      (error) => ({ error }),
    );
    if (!answer.error) {
      const { user_ids } = params;
      this.members = this.members.filter((i) => !(user_ids || []).includes(i.id));
    }
    return { ...answer };
  }
}
